module.exports = __webpack_public_path__ + "static/media/1007342.7317430a.jpg";